import React from 'react';
import Counter from './counter/Counter';
import config from './../../services/config.json'

const Product = ({name, price, slug, min, max, numUnit, unit, lvlname}) =>{

 return(
  <div className="card">
      <img className="card-img-top img-thumbnail" src={`${config.AndroidProductsPictures}/${slug}.jpg`} alt=""/>
      
      <div className="card-body">
        <div className="cardtxt">
          <h5 className="card-text">{name}</h5>
          <p className="card-text text-truncate">{price} ریال</p>
        </div>
      </div>

      <Counter min={min} max={max} unit={unit} numUnit={numUnit}/>
    
  </div>   
  );
}
export default Product;